import { render, staticRenderFns } from "./visit_distribution.vue?vue&type=template&id=22c2ab2b&scoped=true&"
import script from "./visit_distribution.vue?vue&type=script&lang=js&"
export * from "./visit_distribution.vue?vue&type=script&lang=js&"
import style0 from "./visit_distribution.vue?vue&type=style&index=0&id=22c2ab2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c2ab2b",
  null
  
)

export default component.exports